import React from "react";
import Topbar from "../components/Topbar";
import { SchedulePost } from "../components/btn/SchedulePost";
import GalleryPreview from "../components/GalleryPreview";
import Reviews from "../components/Reviews";

const Gallery = () => {
  return (
    <div className="bg-white">
      {/* Topbar */}
      <Topbar />
      <div className="container mx-auto px-6 py-2 md:py-8">
        <div className="mb-24 mt-2">
          <h2 className="text-textSecondary md:font-satoshi font-bold leading-[3rem] text-[2rem] md:text-5xl lg:text-[55px] text-center max-w-5xl mx-auto  md:mb-16">
            Gallery
          </h2>
          <div className="">
            <SchedulePost />
          </div>
        </div>
        <GalleryPreview />
      </div>
      <Reviews />
    </div>
  );
};

export default Gallery;
